import { Column } from "./Column";
import { TextComponent } from "./TextComponent";

interface SectionCardProps {
	img?: string;
	titulo?: string;
	descripcion?: string;
	index?: number;
	children?: React.ReactNode;
	classNameImg?: string;
	responsive?: boolean;
}

export const SectionCard: React.FC<SectionCardProps> = ({ img, titulo, descripcion, index, children, classNameImg = "max-md:w-full aspect-square object-cover rounded-full" }) => {
	return (
		<Column
			key={index}
			className="bg-white rounded-2xl w-full gap-4 shadow-md p-5 border border-gray-200"
			data-sal="fade"
			data-sal-duration="1500"
		>
			{img && (
				<img
					src={img}
					alt={`imagen de referencia de ${titulo}` || "Imagen"}
					draggable={false}
					className={`${classNameImg} shadow select-none`}
				/>
			)}

			<Column className="gap-1 md:gap-2 w-full flex-grow">
				<Column className="text-center gap-1">
					{titulo && (
						<TextComponent
							variant="h5"
							className="font-semibold uppercase font-baskerville "
						>
							{titulo}
						</TextComponent>
					)}
					{descripcion && (
						<TextComponent
							variant="h5"
							className="text-gray-600"
						>
							{descripcion}
						</TextComponent>
					)}
				</Column>
				{children}
			</Column>
		</Column>
	);
};
